// src/api/v2subscriptions.js

import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const V2_SUBSCRIPTIONS_URL = `${BASE_URL}/api/v2/subscriptions`;

const v2SubscriptionsApi = {
  async getPlans() {
    const response = await axios.get(`${V2_SUBSCRIPTIONS_URL}/plans`);
    return response.data;
  },
  async getSubscriptions() {
    const response = await axios.get(`${V2_SUBSCRIPTIONS_URL}`);
    return response.data;
  },
  async pauseSubscription(subscriptionId) {
    const response = await axios.post(`${V2_SUBSCRIPTIONS_URL}/${subscriptionId}/pause`);
    return response.data;
  },
  async resumeSubscription(subscriptionId) {
    const response = await axios.post(`${V2_SUBSCRIPTIONS_URL}/${subscriptionId}/resume`);
    return response.data;
  },
  async subscribe(planId, { mp_device_session_id, token }) {
    const response = await axios.post(`${V2_SUBSCRIPTIONS_URL}/plans/${planId}/subscribe`, { token, mp_device_session_id });
    return response.data;
  },
  async getPayments({ page = 1 }) {
    const response = await axios.get(`${V2_SUBSCRIPTIONS_URL}/payments?page=${page}`);
    return response.data;
  }
};

export default v2SubscriptionsApi;